/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthDocumentSelectionChange } from './PalReauthDocumentSelectionChange';
import {
    PalReauthDocumentSelectionChangeFromJSON,
    PalReauthDocumentSelectionChangeFromJSONTyped,
    PalReauthDocumentSelectionChangeToJSON,
    PalReauthDocumentSelectionChangeToJSONTyped,
} from './PalReauthDocumentSelectionChange';

/**
 * 
 * @export
 * @interface PalReauthDocumentSelectionsRequest
 */
export interface PalReauthDocumentSelectionsRequest {
    /**
     * 
     */
    selections: Array<PalReauthDocumentSelectionChange>;
}

/**
 * Check if a given object implements the PalReauthDocumentSelectionsRequest interface.
 */
export function instanceOfPalReauthDocumentSelectionsRequest(value: object): value is PalReauthDocumentSelectionsRequest {
    if (!('selections' in value) || value['selections'] === undefined) return false;
    return true;
}

export function PalReauthDocumentSelectionsRequestFromJSON(json: any): PalReauthDocumentSelectionsRequest {
    return PalReauthDocumentSelectionsRequestFromJSONTyped(json, false);
}

export function PalReauthDocumentSelectionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthDocumentSelectionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selections': ((json['selections'] as Array<any>).map(PalReauthDocumentSelectionChangeFromJSON)),
    };
}

export function PalReauthDocumentSelectionsRequestToJSON(json: any): PalReauthDocumentSelectionsRequest {
    return PalReauthDocumentSelectionsRequestToJSONTyped(json, false);
}

export function PalReauthDocumentSelectionsRequestToJSONTyped(value?: PalReauthDocumentSelectionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selections': ((value['selections'] as Array<any>).map(PalReauthDocumentSelectionChangeToJSON)),
    };
}

